angular.module('rjmNg.api').factory 'Clients', [
  '$resource'
  '$cacheFactory'
  'serviceUrl'
  (
    $resource
    $cacheFactory
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      get: angular.extend {}, defaultParams,
        method: "GET"
        cache: $cacheFactory.get('Clients') or $cacheFactory('Clients')
      save: angular.extend {}, defaultParams,
        method: 'PUT'

    clientsResource = $resource serviceUrl('/clients/:id'), {}, actions

    clearCache = () ->
      $cacheFactory.get('Clients')?.removeAll()

    Clients =
      get: (clientId, useCache = true) ->
        if not useCache
          clearCache()
        clientsResource.get({id: clientId}).$promise

      save: (client) ->
        clearCache()

        paredModel =
          name: client.name
          properties:
            timezone: client.properties.timezone
            website_url: client.properties.website_url
            phone_number: client.properties.phone_number
            hosted_warehouse: client.properties.hosted_warehouse
            magento_version: client.properties.magento_version
            has_privacy_protection: client.properties.has_privacy_protection
            has_guest_checkout: client.properties.has_guest_checkout
            magento_store_db_name: client.properties.magento_store_db_name
            magento_store_table_prefix: client.properties.magento_store_table_prefix
            default_currency: client.properties.default_currency
            week_start_day: client.properties.week_start_day
            is_implemented: client.properties.is_implemented
            blackout_hours: client.properties.blackout_hours
            perform_updates: client.properties.perform_updates
            stale_email_summary_action: client.properties.stale_email_summary_action
            forced_update_hours: client.properties.forced_update_hours

        clientsResource.save({id: client.id}, paredModel).$promise


    Clients

]
